module.exports = __webpack_public_path__ + "img/Security2_JP@3x.c10b233e.png";